function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSalsa = function SvgSalsa(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FF3C63"
    },
    d: "M256,22C120.69,22,11,131.69,11,267c0,73.208,32.12,138.905,83.023,183.799   c19.078,10.469,125.264,64.212,256.973,42.098C439.126,455.791,501,368.623,501,267C501,131.69,391.31,22,256,22z"
  }), React.createElement("path", {
    style: {
      fill: "#474979"
    },
    d: "M371.745,149.526c0,0-16.003,31.693-2.74,55.542c13.262,23.849-28.089,31.53-18.221,47.425   s-6.578,49.257-45.58,34.691c-39.001-14.567-48.769-51.075-35.897-72.762c12.872-21.687-8.407-51.584,37.788-97.779   L371.745,149.526z"
  }), React.createElement("path", {
    style: {
      fill: "#353966"
    },
    d: "M336.661,221.256c7.5-23.607,22.3-16.298,7.85-58.639c-5.569-16.319-15.269-29.572-25.089-39.703   l-12.328-6.27c-46.195,46.195-24.916,76.092-37.788,97.778c-12.872,21.687-3.104,58.196,35.897,72.762   c39.001,14.567,55.448-18.796,45.58-34.691C350.784,252.493,329.161,244.863,336.661,221.256z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M315.146,226.344l-38.717-96.083l-6.311-87.191c5.453-2.712,14.433-8.191,12.215-14.016   c-1.481-3.893-5.093-3.7-8.523-2.389l0.751-2.987c2.565-10.193-3.619-20.534-13.812-23.099   c-10.191-2.567-20.534,3.618-23.099,13.812L232.6,34.465c-0.607,2.019-0.888,4.167-0.781,6.386   c0.004,0.088,0.001,0.177,0.006,0.265c0.004,0.066-0.001,0.13,0.004,0.197l6.853,94.67c0.001,0.01,0.003,0.019,0.004,0.029   c0.126,1.708,0.571,3.782,1.284,5.587c0.016,0.041,0.026,0.083,0.042,0.123l39.832,98.849c3.94,9.778,15.041,14.456,24.764,10.538   C314.356,247.181,319.076,236.093,315.146,226.344z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M315.146,226.344l-29.845-74.064c-0.48,10.855-9.407,19.515-20.381,19.515   c-6.377,0-12.068-2.924-15.814-7.503l30.737,76.278c3.939,9.777,15.041,14.455,24.764,10.538   C314.356,247.181,319.076,236.093,315.146,226.344z"
  }), React.createElement("path", {
    style: {
      fill: "#A0D5FF"
    },
    d: "M354.758,491.263c-23.424-20.157-38.15-41.32-47.305-60.98c-2.651-5.694-2.692-12.163-0.547-18.066   c6.431-17.694-4.921-36.239-8.046-41.391c-6.344-10.455-4.343-21.797-4.343-21.797l-0.001,0v0l-72.436-26.376   c-18.785,39.135-102.039,43.244-120.523,76.837c-8.238,14.972-11.78,31.861-10.596,48.579C134.505,487.78,192.423,512,256,512   C291.141,512,324.546,504.587,354.758,491.263z"
  }), React.createElement("path", {
    style: {
      fill: "#7EC8F2"
    },
    d: "M321.19,227.716c-3.928-17.855-19.284-24.998-36.068-19.284c-13.801,4.698-17.313-1.14-18.126-3.364   c-0.077,0.001-0.151,0.008-0.228,0.008c-15.476,0-41.436,9.363-32.988,44.251c6.827,28.194-0.963,48.638-11.7,73.325   c0,0,28.856,30.54,72.436,26.376h0.001c6.571-23.582,14.656-52.636,18.657-67.158c1.801-6.541,4.274-12,6.765-17.124   C315.061,254.553,323.984,240.416,321.19,227.716z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M284.881,209.181c16.564-5.639,31.718,1.41,35.595,19.031c2.821,12.826-6.476,27.141-0.882,37.246   c6.991-14.49,14.362-26.043,7.615-51.112c-1.602-5.952-1.467-13.46,0.719-18.426l1.841-4.184c-4.577,1.544-9.43,2.329-14.358,2.26   c-4.044-0.056-7.948-1.781-10.712-4.713c-3.41-3.618-6.128-7.767-8.085-12.229l-3.756,8.538c-0.12,0.113-7.405,19.484-26.09,19.484   C266.768,205.076,268.317,214.82,284.881,209.181z"
  }), React.createElement("polygon", {
    style: {
      fill: "#474979"
    },
    points: "303.273,120.119 303.273,120.119 303.273,120.119  "
  }), React.createElement("path", {
    style: {
      fill: "#474979"
    },
    d: "M334.664,74.985c12.843-0.808,21.617,5.826,26.019,10.648c9.75-1.605,14.486,0.393,18.308,5.383   c12.497,16.315,4.001,46.016-6.392,60.981l0,0l-0.003,0.005c-1.719-0.883-3.917-1.244-5.556-1.018l0,0   c0.267-1.714,0.53-3.852,0.146-5.212c-0.346-1.225-0.309-2.515,0.206-3.665c2.727-6.089,9.006-24.436-11.417-29.654   c-8.598,9.195-27.465,23.384-52.703,7.665l0,0l0,0c-0.839-1.425-2.486-2.926-4.244-3.726l0.002-0.005   C294.564,102.842,312.95,76.352,334.664,74.985z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M292.689,137.452c0,0,4.498-13.689,10.757-19.985c-1.42-2.5-5.205-5.323-7.984-4.517   c-5.689,1.651-5.738,8.575-6.196,12.726c-0.141,1.275-0.433,2.486-0.871,3.624c-0.953,2.473-1.425,6.571,4.015,9.289   C292.503,138.211,292.592,137.836,292.689,137.452z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M297.013,127.112c-1.467,0.287-3.036,0.103-4.465-0.638c-1.394-0.723-2.429-1.86-3.046-3.18   c-0.087,0.849-0.156,1.66-0.235,2.383c-0.141,1.275-0.433,2.486-0.872,3.624c-0.953,2.473-1.425,6.571,4.015,9.289   c0.093-0.379,0.182-0.754,0.28-1.138C292.69,137.452,294.333,132.456,297.013,127.112z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M377.219,155.34c-0.942-2.736-5.431-4.202-8.292-3.922c-1.539,8.743-10.135,20.308-10.135,20.308   c-0.257,0.301-0.513,0.59-0.769,0.884c5.357,2.88,8.433,0.132,9.905-2.072c0.678-1.014,1.499-1.951,2.46-2.801   C373.518,164.971,379.148,160.942,377.219,155.34z"
  }), React.createElement("path", {
    style: {
      fill: "#EAA77A"
    },
    d: "M367.934,165.561c-1.468-0.761-2.545-1.98-3.147-3.391c-2.832,5.299-5.994,9.556-5.994,9.556   c-0.257,0.301-0.513,0.59-0.769,0.884c5.357,2.88,8.433,0.132,9.906-2.072c0.678-1.014,1.499-1.951,2.46-2.801   c0.521-0.461,1.113-0.96,1.727-1.492C370.731,166.457,369.272,166.255,367.934,165.561z"
  }), React.createElement("path", {
    style: {
      fill: "#FCD2AE"
    },
    d: "M369.103,146.722c-0.34-1.264-0.283-2.579,0.271-3.732c3.232-6.732,11.193-28.516-18.898-32.22   c-1.183-0.146-2.289-0.719-3.089-1.602c-20.367-22.458-33.583-3.399-37.223,3.122c-0.623,1.116-1.665,1.921-2.894,2.372   c-8.238,3.019-14.69,22.705-14.69,22.705c-3.064,12.066-3.705,21.877-3.211,29.578c0.585,9.112,4.216,17.858,10.188,25.016   c2.683,3.216,6.625,5.267,10.816,5.608c9.291,0.756,18.532-1.316,26.316-6.089c6.579-4.034,14.228-10.212,22.323-19.669   C359.012,171.812,371.383,155.194,369.103,146.722z"
  }), React.createElement("path", {
    style: {
      fill: "#F9BD91"
    },
    d: "M305.222,175.166c0.478-7.198,2.081-16.51,5.836-28.217c0,0,7.265-19.265,14.058-23.033   c1.013-0.562,1.92-1.437,2.534-2.558c2.406-4.398,8.833-14.59,16.862-15.11c-18.732-17.709-30.882-0.164-34.348,6.044   c-0.623,1.116-1.665,1.921-2.894,2.372c-8.238,3.019-14.69,22.705-14.69,22.705c-3.064,12.066-3.705,21.877-3.211,29.578   c0.585,9.112,4.216,17.858,10.188,25.016c2.683,3.216,6.625,5.267,10.816,5.608c0.006,0.001,0.011,0.001,0.016,0.001   C306.518,191.502,304.658,183.677,305.222,175.166z"
  }), React.createElement("path", {
    style: {
      fill: "#474979"
    },
    d: "M366.458,87.274c0,0-11.446-30.104-43.868-23.76s-38.818,46.405-19.317,56.605   c19.501,10.2,48.317-13.601,63.186-3.503V87.274z"
  }), React.createElement("path", {
    style: {
      fill: "#353966"
    },
    d: "M353.146,71.251c0.452-0.088,0.885-0.145,1.329-0.218c-6.963-5.842-17.294-10.374-31.885-7.519   c-32.423,6.344-38.818,46.405-19.317,56.605c7.914,4.139,17.362,2.679,26.79,0.157C318.386,107.021,326.04,76.555,353.146,71.251z"
  }), React.createElement("path", {
    style: {
      fill: "#7EC8F2"
    },
    d: "M243.661,349.418c2.695-2.695,5.817-8.252,8.877-15.675l-30.458-11.091   c-18.785,39.135-102.039,43.244-120.522,76.837c-8.238,14.972-11.78,31.86-10.596,48.58   c31.528,28.754,70.595,49.376,113.887,58.573c6.976-11.618,36.97-13.858,4.646-57.66   C162.989,385.964,234.546,358.533,243.661,349.418z"
  }), React.createElement("path", {
    style: {
      fill: "#4DADE2"
    },
    d: "M301.288,214.519c0-2.901,1.85-5.363,4.431-6.291c-6.006-2.33-13.16-2.327-20.597,0.204   c-13.801,4.698-17.313-1.14-18.126-3.364c-0.077,0.001-0.151,0.008-0.228,0.008c-15.476,0-41.436,9.363-32.988,44.251   c6.827,28.194-0.963,48.638-11.7,73.325c0,0,10.002,10.574,27.109,18.43c8.35-16.265,17.578-49.376,17.578-79.392   c0-29.83,25.333-41.173,35.107-44.44C301.5,216.416,301.288,215.493,301.288,214.519z"
  }), React.createElement("path", {
    style: {
      fill: "#FCD2AE"
    },
    d: "M311.533,227.79c-3.131-10.033-13.799-15.628-23.835-12.5l-90.492,28.23l-50.25-52.377   c1.302-4.145,5.355-18.844-1.743-21.433c-4.547-1.658-6.803,2.466-7.918,6.59l-3.477-7.275   c-4.533-9.482-15.892-13.501-25.377-8.962c-9.482,4.532-13.495,15.894-8.962,25.377l8.936,18.693   c2.563,6.042,0.997,2.194,69.481,74.237c0.027,0.028,0.058,0.051,0.085,0.079c5.122,5.266,12.652,7.004,19.317,4.914   l101.737-31.739C309.066,248.494,314.662,237.822,311.533,227.79z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSalsa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salsa.84bd7ba0.svg";
export { ForwardRef as ReactComponent };